export default __webpack_public_path__ + "static/formation-utiliser-e1ad0a83f767a47359f1337dfdeacec0.png";